<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager']"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
      <li>
        Neu
      </li>
    </ul>
  </div>
</div>

<div class="page-content px-4 pb-2 overflow-auto">
  <form class="page-sheet max-w-7xl mx-auto" [formGroup]="warehouseForm" (submit)="onSubmit()">
    <div class="grid grid-cols-3">
      <fieldset class="bm-fieldset p-4 row-span-3">
        <legend class="bm-fieldset-legend text-lg">Stammdaten</legend>
        <ng-container [ngTemplateOutlet]="tplStammdaten" />
      </fieldset>

      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Beschränkung der Artikelvorlagen</legend>
        <ng-container [ngTemplateOutlet]="tplVorlagen" />
      </fieldset>

      <fieldset class="bm-fieldset p-4 relative">
        <legend class="bm-fieldset-legend text-lg">Adresse</legend>
        <ng-container [ngTemplateOutlet]="tplAddress" />
      </fieldset>
    </div>

    <div class="flex flex-row gap-2 items-center justify-end mt-4">
      <a [routerLink]="'/lager/uebersicht'" class="bm-btn"> Abbrechen </a>
      <button class="bm-btn bm-btn-primary" [disabled]="!warehouseForm.valid">Erstellen</button>
    </div>
  </form>
</div>

<ng-template #tplStammdaten>
  <label class="bm-fieldset-label">Label</label>
  <input class="bm-input w-full" type="text" [formControl]="warehouseForm.controls.label" [ngClass]="{ 'border-red-500': warehouseForm.controls.label.invalid }"/>

  <label class="bm-fieldset-label">Techniker</label>
  <select class="bm-select w-full" [formControl]="warehouseForm.controls.user_id" [ngClass]="{ 'border-red-500': warehouseForm.controls.user_id.invalid }">
    <option value="">-Keine Zuordnung-</option>
    @for (user of technicians; track $index) {
      <option [ngValue]="user.id">{{ user.name }}</option>
    }
  </select>

  <label class="bm-fieldset-label">Telefon</label>
  <input class="bm-input w-full" type="text" [formControl]="warehouseForm.controls.telephone" [ngClass]="{ 'border-red-500': warehouseForm.controls.telephone.invalid }"/>

  <label class="bm-fieldset-label">
    <input type="checkbox" class="bm-checkbox" [formControl]="warehouseForm.controls.main_warehouse" /> Hauptlager
  </label>

  <label class="bm-fieldset-label">
    <input type="checkbox" class="bm-checkbox" [formControl]="warehouseForm.controls.freefill" /> Free fill
  </label>
</ng-template>


<ng-template #tplVorlagen>
  <label class="bm-fieldset-label">Kommentar 1</label>
  <input class="bm-input w-full" type="text" [formControl]="warehouseForm.controls.limit_template1" [ngClass]="{ 'border-red-500': warehouseForm.controls.limit_template1.invalid }"/>

  <label class="bm-fieldset-label">Kommentar 2</label>
  <input class="bm-input w-full" type="text" [formControl]="warehouseForm.controls.limit_template2" [ngClass]="{ 'border-red-500': warehouseForm.controls.limit_template2.invalid }"/>

  <label class="bm-fieldset-label">Kommentar 3</label>
  <input class="bm-input w-full" type="text" [formControl]="warehouseForm.controls.limit_template3" [ngClass]="{ 'border-red-500': warehouseForm.controls.limit_template3.invalid }"/>
</ng-template>

<ng-template #tplAddress>
  <div class="flex_row geocoder_container absolute -top-6 right-0">
    <div class="geocoder" id="address_geocoder"></div>
  </div>
  <label class="bm-fieldset-label">Firma</label>
  <input class="bm-input w-full" type="text" [formControl]="warehouseForm.controls.company" />

  <label class="bm-fieldset-label">Name</label>
  <div class="flex flex-row gap-2">
    <input class="bm-input flex-1" type="text" [formControl]="warehouseForm.controls.firstname" placeholder="Vorname"/>
    <input class="bm-input flex-1" type="text" [formControl]="warehouseForm.controls.lastname" placeholder="Nachname"/>
  </div>

  <label class="bm-fieldset-label">Straße</label>
  <input class="bm-input w-full" type="text" [formControl]="warehouseForm.controls.street" />

  <label class="bm-fieldset-label">PLZ / Ort</label>
  <div class="flex flex-row gap-2">
    <input class="bm-input flex-1" type="text" [formControl]="warehouseForm.controls.zip" [ngClass]="{ 'border-red-500': warehouseForm.controls.zip.invalid }"/>
    <input class="bm-input flex-2" type="text" [formControl]="warehouseForm.controls.city" />
  </div>

  <label class="bm-fieldset-label">Land / Staat</label>
  <div class="flex flex-row gap-2">
    <input class="bm-input flex-1" type="text" [formControl]="warehouseForm.controls.country" />
    <input class="bm-input flex-2" type="text" [formControl]="warehouseForm.controls.state" />
  </div>
</ng-template>
